import { normalizeAppLocale } from '~/utils/appLocale'

const LANDING_PATHS = new Set(['/', '/privacy-policy', '/terms-of-use'])

function requestIsSecure() {
  return useRequestURL().protocol === 'https:'
}

function localeCookieOptions() {
  return {
    sameSite: 'lax' as const,
    secure: requestIsSecure(),
    path: '/',
  }
}

function withoutLocale(path: string) {
  const stripped = path.replace(/^\/(fr|it|de|hy|ru)(?=\/|$)/, '') || '/'
  const normalized = stripped.startsWith('/') ? stripped : `/${stripped}`
  return normalized.replace(/\/+$/, '') || '/'
}

export default defineNuxtRouteMiddleware((to) => {
  if (to.path.startsWith('/_')) return

  const hostSlug = getRestaurantSlugFromHost(to.query as Record<string, any>)
  const isWasabi = hostSlug === 'wasabi' || slugForCustomRestaurantHost(useRequestURL().hostname) === 'wasabi'
  if (!isWasabi) return

  const path = withoutLocale(to.path)
  if (!LANDING_PATHS.has(path)) return

  const pathLocale = normalizeAppLocale(to.path.match(/^\/(fr|it|de|hy|ru)(?=\/|$)/)?.[1])
  const languageCookie = useCookie<string | null>('language', localeCookieOptions())
  const currentLanguageCookie = useCookie<string | null>('currentLanguage', localeCookieOptions())
  const savedFromStorage = process.client
    ? normalizeAppLocale(localStorage.getItem('currentLanguage')) || normalizeAppLocale(localStorage.getItem('i18n_redirected'))
    : null
  const saved = normalizeAppLocale(languageCookie.value) || normalizeAppLocale(currentLanguageCookie.value) || savedFromStorage

  if (saved || pathLocale) return

  languageCookie.value = 'hy'
  currentLanguageCookie.value = 'hy'
  const i18nCookie = useCookie<string | null>('i18n_redirected', localeCookieOptions())
  i18nCookie.value = 'hy'

  const localizedPath = path === '/' ? '/hy' : `/hy${path}`
  return navigateTo({ path: localizedPath, query: to.query }, { redirectCode: 302 })
})
